module.exports = __webpack_public_path__ + "static/media/ic-classting.1b697684.svg";